import React from "react";

function Icon({ Component, fill }) {
  return <Component fill={fill} />;
}

export default Icon;
